
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon material-block","d":"M14 0a14 14 0 1014 14A14.005 14.005 0 0014 0zM2.8 14A11.2 11.2 0 0114 2.8a11.063 11.063 0 016.86 2.366L5.166 20.86A11.063 11.063 0 012.8 14zM14 25.2a11.063 11.063 0 01-6.86-2.366L22.834 7.14A11.063 11.063 0 0125.2 14 11.2 11.2 0 0114 25.2z","fill":"#ff6868"}})])
          )
        }
      }
    